import React, { useState } from 'react';

const REPORT_TYPES = [
  {
    icon: '\uD83D\uDCB0',
    title: 'Revenue Report',
    description: 'Detailed breakdown of income, expenses, and profit margins across all accounts.',
    color: '#10b981'
  },
  {
    icon: '\uD83D\uDC65',
    title: 'Customer Report',
    description: 'Customer acquisition, retention rates, and engagement metrics over time.',
    color: '#6366f1'
  },
  {
    icon: '\uD83D\uDEE0\uFE0F',
    title: 'Job Report',
    description: 'Job completion rates, average duration, and resource allocation summary.',
    color: '#f59e0b'
  },
  {
    icon: '\uD83D\uDCDC',
    title: 'Compliance Report',
    description: 'Safety audit results, SOP adherence, and regulatory compliance status.',
    color: '#ef4444'
  },
];

export default function ReportsPage() {
  const [dateRange, setDateRange] = useState({});

  const handleGenerate = (title) => {
    alert(`Generating ${title}...\n\nThis would export a detailed PDF report in a production environment.`);
  };

  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div className="page-header" style={{ marginBottom: 28 }}>
        <h1 className="page-title" style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>
          Reports
        </h1>
        <p className="page-subtitle" style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>
          Generate and export operational reports
        </p>
      </div>

      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 20
      }}>
        {REPORT_TYPES.map((report, i) => (
          <div key={i} className="card" style={{
            padding: 24, background: 'var(--card)', borderRadius: 12,
            border: '1px solid var(--border)', display: 'flex', flexDirection: 'column'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
              <div style={{
                width: 44, height: 44, borderRadius: 10,
                background: `${report.color}20`, display: 'flex',
                alignItems: 'center', justifyContent: 'center', fontSize: 22
              }}>
                {report.icon}
              </div>
              <h3 className="card-title" style={{ color: 'var(--text)', fontSize: 16, fontWeight: 600, margin: 0 }}>
                {report.title}
              </h3>
            </div>

            <p style={{ color: 'var(--text-secondary)', fontSize: 13, lineHeight: 1.6, margin: '0 0 18px', flex: 1 }}>
              {report.description}
            </p>

            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', color: 'var(--text-muted)', fontSize: 11, fontWeight: 600, marginBottom: 5, textTransform: 'uppercase' }}>
                Date Range
              </label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  className="input"
                  type="date"
                  value={dateRange[`${i}_start`] || ''}
                  onChange={(e) => setDateRange({ ...dateRange, [`${i}_start`]: e.target.value })}
                  style={{
                    flex: 1, padding: '8px 10px', background: 'var(--bg)',
                    border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text)',
                    fontSize: 12, outline: 'none'
                  }}
                />
                <input
                  className="input"
                  type="date"
                  value={dateRange[`${i}_end`] || ''}
                  onChange={(e) => setDateRange({ ...dateRange, [`${i}_end`]: e.target.value })}
                  style={{
                    flex: 1, padding: '8px 10px', background: 'var(--bg)',
                    border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text)',
                    fontSize: 12, outline: 'none'
                  }}
                />
              </div>
            </div>

            <button
              className="btn btn-primary"
              onClick={() => handleGenerate(report.title)}
              style={{
                width: '100%', padding: '10px 0', background: report.color, color: '#fff',
                border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer'
              }}
            >
              Generate Report
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
